import { useEffect, useState } from "react";
import API from "../../services/api";

import HeroSection from "../../components/customer/HeroSection/HeroSection";

import FilterBar from "../../components/customer/FilterBar/FilterBar";
import RecommendedForYou from "../../components/customer/RecommendedForYou/RecommendedForYou";
import PopularFoods from "../../components/customer/PopularFoods/PopularFoods";
import StickyCartBar from "../../components/customer/providerDetails/StickyCartBar";
import NearbyProviders from "../../components/customer/NearbyProviders/NearbyProviders";
import socket from "../../services/socket";
import "./CustomerHome.css";

function CustomerHome() {

  const [loading, setLoading] = useState(true);

  // ==========================
  // Filters
  // ==========================

  const [filters, setFilters] = useState({
    category: "",
    foodType: "",
    providerType: "",
    maxPrice: "",
    sort: "",
    fastDelivery: false,
    rating: "",
    openNow: false,
    offersOnly: false,
  });

  // ==========================
  // Home Data
  // ==========================

  const [homeData, setHomeData] = useState({
    banners: [],
    serviceCategories: [],
    foodCategories: [],
    filterOptions: {},
    recommendedCategories: [],
    nearbyBusinesses: [],
    todaysSpecials: [],
    featuredFoods: [],
    recommendedFoods: [],
    popularFoods: [],
    trendingFoods: [],
  });

  // ==========================
  // Initial Load
  // ==========================

  useEffect(() => {
    loadHome(filters);
  }, []);

  useEffect(() => {

    const user = JSON.parse(

        localStorage.getItem("user")

    );

    if(user){

        socket.emit(

            "register",

            user.id

        );

    }

}, []);

  // ==========================
  // Reset Filters
  // ==========================

  const handleResetFilters = () => {

    const resetFilters = {
      category: "",
      foodType: "",
      providerType: "",
      maxPrice: "",
      sort: "",
      fastDelivery: false,
      rating: "",
      openNow: false,
      offersOnly: false,
    };

    setFilters(resetFilters);

    loadHome(resetFilters);

  };

  // ==========================
  // Load Home
  // ==========================

  const loadHome = async (
    currentFilters = filters
  ) => {

    try {

      setLoading(true);

      const params = {};

      if (currentFilters.category)
        params.category = currentFilters.category;

      if (currentFilters.foodType)
        params.foodType = currentFilters.foodType;

      if (currentFilters.providerType)
        params.providerType = currentFilters.providerType;

      if (currentFilters.maxPrice)
        params.maxPrice = currentFilters.maxPrice;

      if (currentFilters.sort)
        params.sort = currentFilters.sort;

      if (currentFilters.fastDelivery)
        params.fastDelivery = true;
            const res = await API.get(
        "/customer/home",
        {
          params,
        }
      );

      if (res.data.success) {

        setHomeData(res.data.data);

      }

    } catch (error) {

      console.error(
        "Failed to load home data",
        error
      );

    } finally {

      setLoading(false);

    }

  };

  // ==========================
  // Filter Change
  // ==========================

  const handleFilterChange = (
    key,
    value
  ) => {

    const updatedFilters = {
      ...filters,
      [key]: value,
    };

    setFilters(updatedFilters);

    loadHome(updatedFilters);

  };

  // ==========================
  // Recommended Category Click
  // ==========================

  const handleRecommendedClick = (
    category
  ) => {

    const updatedFilters = {
      ...filters,
      category,
    };

    setFilters(updatedFilters);

    loadHome(updatedFilters);

  };

  // ==========================
  // Loading Screen
  // ==========================

  if (loading) {

    return (

      <div className="customer-home-loading">

        <h2>
          Loading Home...
        </h2>

      </div>

    );

  }

  return (

    <div className="customer-home">

     <HeroSection
    banners={homeData.banners}
/>




      <FilterBar
        filters={filters}
        onFilterChange={handleFilterChange}
        onReset={handleResetFilters}
      />

      <RecommendedForYou
  foods={homeData.recommendedCategories}
  onSelect={handleRecommendedClick}
/>

<PopularFoods
  foods={homeData.popularFoods}
/>

<NearbyProviders
  providers={homeData.nearbyBusinesses}
/>
<StickyCartBar />
            {/* ==========================
          Future Sections
      ========================== */}

      {/*
      <TodaysSpecials
        items={homeData.todaysSpecials}
      />

      <FeaturedItems
        items={homeData.featuredFoods}
      />

      <TrendingItems
        items={homeData.trendingFoods}
      />
      */}

    </div>

  );

}

export default CustomerHome;